// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3n1wG","file":"styles_file__Nr4JJ"};